import { render, staticRenderFns } from "./TemplateDocumentItem.vue?vue&type=template&id=27776ac2&"
import script from "./TemplateDocumentItem.vue?vue&type=script&lang=js&"
export * from "./TemplateDocumentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports